angular.module('autoremind.communications')
    .directive('communicationsTargetSales', ['jobService', function (jobService) {
        return {
            restrict: 'E',
            scope: true,
            templateUrl: 'app/communication/forms/communications-target-sales.html',
            link: function () {
                jobService.minAppointmentOptions = [
                    { "label": "N/A", "value": 0 },
                    { "label": "0", "value": -1 },
                    { "label": "1", "value": 1 },
                    { "label": "2", "value": 2 },
                    { "label": "3", "value": 3 },
                    { "label": "4", "value": 4 },
                    { "label": "5", "value": 5 },
                    { "label": "6", "value": 6 },
                    { "label": "7", "value": 7 },
                    { "label": "8", "value": 8 },
                    { "label": "9", "value": 9 },
                    { "label": "10", "value": 10 }
                ];
            }
        };
    }]);
//# sourceMappingURL=communications-target-sales.js.map